import { render } from "./TongShiPage.vue?vue&type=template&id=3b46e222&scoped=true"
import script from "./TongShiPage.vue?vue&type=script&lang=js"
export * from "./TongShiPage.vue?vue&type=script&lang=js"

import "./TongShiPage.vue?vue&type=style&index=0&id=3b46e222&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b46e222"]])

export default __exports__